<template>
  <div style="width: 100%;">
    <b-col cols="12">
      <div class="divider divider-solid">
        <div
          class="divider-text"
          style="font-weight: 600;"
        >
          Seo
        </div>
      </div>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="MetaTitle"
        label-for="MetaTitle"
      >
        <b-form-input
          id="MetaTitle"
          :value="localForm.MetaTitle"
          name="MetaTitle"
          autocomplete="off"
          @input="updateField('MetaTitle', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="ImageAlt"
        label-for="ImageAlt"
      >
        <b-form-input
          id="ImageAlt"
          :value="localForm.ImageAlt"
          name="ImageAlt"
          autocomplete="off"
          @input="updateField('ImageAlt', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="MetaDescription"
        label-for="MetaDescription"
      >
        <b-form-input
          id="MetaDescription"
          :value="localForm.MetaDescription"
          name="MetaDescription"
          autocomplete="off"
          @input="updateField('MetaDescription', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col md="12">
      <b-form-group
        label="MetaKeywords"
        label-for="MetaKeywords"
      >
        <b-form-input
          id="MetaKeywords"
          :value="localForm.MetaKeywords"
          name="MetaKeywords"
          autocomplete="off"
          @input="updateField('MetaKeywords', $event)"
        />
      </b-form-group>
    </b-col>
  </div>
</template>

<script>
export default {
  name: 'ZSeo',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localForm: { ...this.value },
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.localForm = { ...newVal }
      },
      deep: true,
    },
  },
  methods: {
    updateField(field, value) {
      this.localForm[field] = value
      this.$emit('input', { ...this.localForm })
    },
  },
}
</script>
